module.exports = "<h5>Not Found</h5>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = 510
// module chunks = 1